import { NgSelectComponent } from '@ng-select/ng-select';
import { Component, OnInit, Input, forwardRef, ViewChild, ElementRef, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { isObservable, Observable, Subscription } from 'rxjs';
import { finalize, shareReplay, tap } from 'rxjs/operators';
import { SharedComponentsUtil } from '../utils/classes/SharedComponentsUtil';
import { MessageUtilService } from '../utils/service/message-util.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { NgSelectMultipleService } from './ng-select-multiple.service';

@Component({
  selector: 'ng-select-multiple',
  templateUrl: './ng-select-multiple.component.html',
  styleUrls: ['./ng-select-multiple.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgSelectMultipleComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NgSelectMultipleComponent),
      multi: true,
    }
  ]
})

@AutoUnsubscribe()
export class NgSelectMultipleComponent implements OnInit, OnChanges, OnDestroy {


  @ViewChild('ngSelectMultiple') ngSelectMultiple!: NgSelectComponent;

  onChange = (_: any) => { };
  onTouched = () => { };
  onValidationChange = () => { };

  @Input() items!: Observable<any[]>;
  @Input() showlimit: number = 2;
  @Input() showLabel: boolean = true;
  @Input() label: any = null;
  @Input() autocomplete: string = "cc-csc";
  @Input() Header: boolean = true;
  @Input() Footer: boolean = true;
  @Input() required: boolean = false;
  @Input() next: any;
  @Input() nextIsDisable: any;
  @Input() back: any;
  @Input() backIsDisable: any;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() openWhenFocus: boolean = false;
  @Input() markFirst: boolean = false;

  @Input() validatorMessage: boolean = false;
  @Input() tooltipMessage: boolean = true;
  @Input() validatorAlert: boolean = false;
  @Input() submitted: boolean = true;
  @Input() refresh: boolean = false;
  @Input() appendTo: any = "body"
  @Input() Language: any = {
    Selected: 'Seleccionados',
    SelectAll: 'TODOS',
    UnselectAll: 'NINGUNO',
    All: 'TODOS'
  };

  @Input() loading: boolean = true;
  @Input() loadingText: string = "Cargando...";

  //EVENTS
  @Output() onNext: EventEmitter<any> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() onfocus: EventEmitter<any> = new EventEmitter();
  @Output() onrefresh: EventEmitter<any> = new EventEmitter();
  sharedComponentsUtil = new SharedComponentsUtil();

  _value: any;
  controls: any;
  all: any;
  checkedAll = false;
  checkedIndeterminate = false;

  private items$!: Subscription;

  constructor(
    private cdrf: ChangeDetectorRef,
    private messageUtilService: MessageUtilService,
    private ngSelectMultipleService: NgSelectMultipleService
  ) {
    this.showlimit = this.ngSelectMultipleService.getShowlimit();
    this.Header = this.ngSelectMultipleService.getHeader();
    this.Footer = this.ngSelectMultipleService.getFooter();
    this.validatorMessage = this.ngSelectMultipleService.getValidatorMessage();
    this.tooltipMessage = this.ngSelectMultipleService.getTooltipMessage();
    this.openWhenFocus = this.ngSelectMultipleService.getOpenWhenFocus();
    this.submitted = this.ngSelectMultipleService.getSubmitted();
    this.validatorAlert = this.ngSelectMultipleService.getValidatorAlert();
    this.appendTo = this.ngSelectMultipleService.getAppendTo();
    this.loadingText = this.ngSelectMultipleService.getLoadingText();
    this.markFirst = this.ngSelectMultipleService.getMarkFirst();
  }

  ngOnDestroy(): void {
  }

  validate(control: AbstractControl): ValidationErrors | any {
    this.controls = control;
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.loading = true;
      if (isObservable(this.items)) {
        this.carga();
        // this.setAll();
        // this.items$ = this.items.pipe(finalize(() => {
        //   this.loading = false;
        //   this.cdrf.markForCheck();
        // })).subscribe(res => {
        //   this.cdrf.markForCheck();
        // })
      } else {
        this.all = this.items;
        this.loading = false;
      }
    }
    if (changes.submitted) {
      if (this.controls !== undefined && changes.submitted.currentValue) {
        this.controls.markAsDirty();
        this.controls.markAsTouched();
      }
    }
  }

  async carga() {
    this.all = await new Promise((resolve, reject) => {
      this.items = this.items.pipe(shareReplay({ refCount: true }));
      this.items$ = this.items.subscribe(res => {
        resolve(res);
      });
    });
    this.loading = false;
  }

  checkIfObservable(items: any) {
    if (isObservable(items))
      return true;
    else
      return false;
  }

  eventFocus(e: any) {
    this.onfocus.emit(e);
    if (this.openWhenFocus) {
      this.ngSelectMultiple.open();
    }
  }

  eventBlur(e: any) {
    this.onTouched();
    this.onValidationChange();
    this.blur.emit(e);
  }

  focus = () => {
    this.ngSelectMultiple.focus();
    if (this.openWhenFocus) {
      this.ngSelectMultiple.open();
    }
  }
  onRefresh() {
    this.onrefresh.emit();
  }

  close = () => {
    this.ngSelectMultiple.close();
  }


  ngOnInit() {
    if (isObservable(this.items)) {
      //this.setAll();
    }
    else {
      this.all = this.items;
    }
  }
  setAll() {
    this.items$ = this.items.subscribe(res => {
      this.all = res;
    });
  }

  writeValue(value: any): void {
    if (value) {
      this._value = value;
    } else {
      this._value = [];
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectAll(e: any) {
    if (e.checked) {
      this.writeValue(this.all);
      this.onChange(this.all);
    } else {
      this.writeValue([]);
      this.onChange([]);
    }
    this.checkedIndeterminate = false;
    this.ngSelectMultiple.focus();
    this.cdrf.markForCheck;
  }

  eventChange(e: any) {
    if (e.length == this.all.length) {
      this.checkedAll = true;
      this.checkedIndeterminate = false;
    } else if (e.length == 0) {
      this.checkedAll = false;
      this.checkedIndeterminate = false;
    } else {
      this.checkedAll = false;
      this.checkedIndeterminate = true;
    }
    this.writeValue(e);
    this.onChange(e);
    this.change.emit(e);

  }

  rightKeyUp() {
    this.ngSelectMultiple.close();
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(this.controls, this.validatorAlert, this.label);
      if (validator.error) {
        this.messageUtilService.getMessageError("000046", "Error", validator.message);
        return;
      }
    }
    if (this.next != undefined) {
      if (this.next.disabled || this.next.readonly) {
        if (this.nextIsDisable != undefined) {
          this.nextIsDisable.focus();
        }
      } else {
        this.next.focus();
      }
    } else {
      if (this.nextIsDisable != undefined) {
        this.nextIsDisable.focus();
      } else {
        this.onNext.emit();
      }
    }
  }

  leftKeyUp() {
    this.ngSelectMultiple.close();
    if (!this.disabled) {
      let validator = this.sharedComponentsUtil.stopByValidator(this.controls, this.validatorAlert, this.label);
      if (validator.error) {
        this.messageUtilService.getMessageError("000046", "Error", validator.message);
        return;
      }
    }
    if (this.back != undefined) {
      if (this.back.disabled || this.back.readonly) {
        if (this.backIsDisable != undefined) {
          this.backIsDisable.focus();
        }
      } else {
        this.back.focus();
      }
    } else {
      if (this.backIsDisable != undefined) {
        this.backIsDisable.focus();
      } else {
        this.onBack.emit();
      }
    }
  }

}
